let language = {
    "A1101P2300003": "The username or password you entered is incorrect. Please double-check your credentials and try again.",
    "A1101B211184": "Your email is incorrect, please check your email. If you don't have an account, go 'sign up' to create a new account.",
    "A1101B211187": "Your registration mail has been used, please change another mail and try register again.",
    "A1101B211186": "Your registration email is the same as your password, which poses a low security risk. Please update your password and try register again later.",
    "A1101B21620956": "old password incorrect",
    "A1101B21850982": "verify token expire",
    "A1101B22417899": "email already used",
    "A1101B300336": "Modify the token of the user mailbox has expired",
    "A1101B22419640": "It looks like your email hasn't been activated yet, so you can't log in at the moment. You can use the \"Forgot Password\" feature to send a password reset email. Resetting your password will also activate your account.",
    "A1101B2185100": "You are visiting our service too frequently. Please try again later",
    "A1101B5010003": "The new password cannot be the same as the old password !",


    // login
    "USER_LOGIN_FAIL_TITLE": "Login unsuccessful",
    "PARTNER_NOT_ACTIVATED": "Your partner is not activated.",

    // resend email
    "PARTNER_EMAIL_INCORRECT": "Your email is incorrect",
    "EMAIL_RESEND_FAIL_TITLE": "Email resend failed",

    // 
    // "": "",

    // regist
    "USER_REGIST_FAIL_TITLE": "Register failed",
    // 用户邮箱已注册
    "USER_REGIST_EMAIL_EXISTS_TITLE": "Email Already Registered",
    "USER_REGIST_EMAIL_EXISTS_CONTENT1": 'It looks like the email address you entered is already registered. If you forgot your password or need to access your account, please use the "Forgot Password" feature to reset it.',
    // 用户邮箱|用户名与密码相同
    "USER_SAME_EMAIL_PASSWORD_TITLE": "Change your password",
    "USER_SAME_EMAIL_PASSWORD_CONTENT1": "Your password cannot be the same as your email address. Please set your password and try again.",
    "USER_SAME_EMAIL_PASSWORD_CONTENT2": "Your password cannot be the same as your account full name. Please enter another password.",
    // 用户谷歌验证失败
    "USER_GOOGLE_RECAPTCHA_VERIFICATION_FAILED_TITLE": "Google reCAPTCHA Verification Failed",
    // 用户邮箱未激活
    "LOGIN_EMIAL_NOT_ACTIVATED_TITLE": "Email Not Activated"
};

export { language }